var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-24 h-24"},[_c('iCon',{staticClass:"overflow-hidden",attrs:{"iconClass":'dropdown',"type":"svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }